module.exports = __webpack_public_path__ + "img/trailerRearLeftOutline.0cec3dba.svg";